import { memo } from 'react';
import { UserRegister3Template1 } from 'components/templates/UserRegister3Template1';

type Props = {};

export const UserRegister3Page1 = memo((_props: Props) => {
	return <UserRegister3Template1 />;
});
